namespace $.$$ {

	$mol_style_define( $rise_devtools_selector_overlay, {
		position: 'fixed',
		boxSizing: 'border-box',
		border: {
			width: '2px',
			style: 'solid',
			color: '#2f80ed',
		},

		Panel: {
			position: 'absolute',
			top: '100%',
			left: '-2px',
			display: 'flex',
			flexDirection: 'column',
			gap: '4px',
			alignItems: 'flex-start',
			background: {
				color: $mol_theme.back,
			},
			border: {
				width: '2px',
				style: 'solid',
				color: '#2f80ed',
			},
		},

		Label: {
			maxWidth: '520px',
			padding: {
				top: '2px',
				right: '6px',
				bottom: '2px',
				left: '6px',
			},
			background: {
				color: '#2f80ed',
			},
			color: 'white',
			font: {
				size: '12px',
				family: 'monospace',
			},
			lineHeight: '16px',
			whiteSpace: 'normal',
			overflow: 'hidden',
			display: 'flex',
			flexDirection: 'column',
			gap: '2px',
		},

		Title: {
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
		},
	} )

}
